import React, { FunctionComponent } from 'react';
import { connect, ResolveThunks } from 'react-redux';

import { RootState } from '../../../../../store';
import { updateInsertingTrussFromSettings } from '../../../../../store/actions/insertComponentDesignActions';
import { loadAnalysisSettings, loadLoadSettings } from '../../../../../store/actions/loadActions';
import { patchDesignStandard, saveLoadSettings } from '../../../../../store/actions/settingsActions';
import { settingsShouldBeViewOnly } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { setInsertionDesignStandard, setInsertionLoadSettings } from '../../../../../store/slices/applicationSlice';
import SettingsPanelContainer, { connectSettingsPanelContainer } from '../SettingsPanelContainer';
import { LoadSettingsWithDesignStandard, SingleLoadSettingsControls } from './LoadSettingsControls';

const LoadSettingsPanelContainer = connectSettingsPanelContainer(
  class extends SettingsPanelContainer<LoadSettingsWithDesignStandard> {},
);

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

const LoadSettingsPanel: FunctionComponent<Props> = (props) => (
  <LoadSettingsPanelContainer
    isViewOnly={props.viewOnly}
    controls={SingleLoadSettingsControls}
    fetchSettings={{
      fromInsertionInfo: (insertionInfo) => ({
        loadSettings: insertionInfo.loadSettings,
        designStandard: insertionInfo.analysisSettings.designStandard,
      }),
      fromSettingsDatabase: async (modelGuid) => {
        const [loadSettings, analysisSettings] = await Promise.all([
          props.loadLoadSettings(modelGuid),
          props.loadAnalysisSettings(modelGuid),
        ]);
        return { loadSettings, designStandard: analysisSettings.designStandard };
      },
    }}
    onSave={{
      forInsertionComponent: async (newLoadSettingsWithDesignStandard, originalLoadSettingsWithDesignStandard) => {
        props.setInsertionLoadSettings({ settings: newLoadSettingsWithDesignStandard.loadSettings, state: 'modified' });
        if (
          newLoadSettingsWithDesignStandard.designStandard !== originalLoadSettingsWithDesignStandard.designStandard
        ) {
          props.setInsertionDesignStandard({ designStandard: newLoadSettingsWithDesignStandard.designStandard });
        }
        await props.updateInsertingTrussFromSettings({ preview: true });
      },
      forExistingModel: async (newLoadSettingsWithDesignStandard, options, originalLoadSettingsWithDesignStandard) => {
        await props.saveLoadSettings(newLoadSettingsWithDesignStandard.loadSettings, options);
        if (
          newLoadSettingsWithDesignStandard.designStandard !== originalLoadSettingsWithDesignStandard.designStandard
        ) {
          await props.patchDesignStandard(newLoadSettingsWithDesignStandard.designStandard, options);
        }
      },
    }}
  />
);

const mapStateToProps = (state: RootState) => ({
  viewOnly: settingsShouldBeViewOnly(state),
});

const actionCreators = {
  loadAnalysisSettings,
  loadLoadSettings,
  patchDesignStandard,
  saveLoadSettings,
  setInsertionLoadSettings,
  setInsertionDesignStandard,
  updateInsertingTrussFromSettings,
};

export default connect(mapStateToProps, actionCreators)(LoadSettingsPanel);
